import { render, staticRenderFns } from "./loading-instance.vue?vue&type=template&id=b215ff58&scoped=true&"
import script from "./loading-instance.vue?vue&type=script&lang=js&"
export * from "./loading-instance.vue?vue&type=script&lang=js&"
import style0 from "./loading-instance.vue?vue&type=style&index=0&id=b215ff58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b215ff58",
  null
  
)

export default component.exports